"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcChip2 = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var AcAutocomplete_module_scss_1 = __importDefault(require("./AcAutocomplete.module.scss"));
var AcChip2 = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, tooltip = _a.tooltip, onDelete = _a.onDelete, item = _a.item, titleMaxWidth = _a.titleMaxWidth, block = _a.block;
    var deleteChip = function () {
        onDelete === null || onDelete === void 0 ? void 0 : onDelete(item);
    };
    return (react_1.default.createElement("div", { title: "" + (tooltip || ''), className: clsx_1.default("d-flex align-items-center bg-apzlightblue rounded-lg pl-3 pr-2 py-1 ml-2 my-1 flex-shrink-2 " + AcAutocomplete_module_scss_1.default.chip, { 'min-width-0': true }) },
        react_1.default.createElement("div", { className: "text-truncate text-dark pr-2 fs-14 flex-shrink-1 min-width-0", style: { maxWidth: titleMaxWidth } }, title),
        subtitle && (react_1.default.createElement("div", { className: "mr-2 text-truncate flex-shrink-1 fs-11 min-width-0", style: {} }, subtitle)),
        react_1.default.createElement("i", { onClick: deleteChip, className: "far fa-times text-secondary fa-fw fs-18", style: {
                flexBasis: 18,
                cursor: 'pointer',
            } })));
};
exports.AcChip2 = AcChip2;
exports.AcChip2.displayName = 'AcChip2';
//# sourceMappingURL=AcChip2.js.map